module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('strong', [_vm._v("GOT SO MUCH CHIPS, I SWEAR THEY CALL ME HEWLETTPACKARD")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LYRIC FROM SONG: "), _c('strong', [_vm._v("“LOLLIPOP (REMIX)”")]), _vm._v(" ON ALBUM: "), _c('strong', [_vm._v("THA CARTER III (ITUNES BONUS TRACK)")]), _vm._v(" BY ARTIST")]), _vm._v(": "), _c('strong', [_vm._v("LIL WAYNE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I am so wealthy that people might mistakenly refer to me by the name of a large multinational computer manufacturer whose integrated circuits are commonly referred to by the same name that I and others use for money.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e5b35b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01ch01.vue
// module id = 81
// module chunks = 0